<template>
  <div class="container">
    <div id="header">
      <div class="flex flex-row-left  margin-top-20 ">
        <div class="flex-item-left">
          <el-form :inline="true" :model="form" class="demo-form-inline">
            <el-form-item label="时间" style="margin-right: 30px">
              <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  :shortcuts="dateShortcuts"
              />
            </el-form-item>
            <el-form-item label="销售编号：" style="margin-right: 30px">
              <el-input style="width:300px" v-model="form.poNumber" placeholder="请输入销售编号" clearable @keyup.enter="onSubmit"/>
            </el-form-item>
            <el-form-item label="客户名称：" style="margin-right: 30px">
              <el-input style="width:300px" v-model="form.customers" placeholder="请输入客户名称" clearable @keyup.enter="onSubmit"/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">查询</el-button>
              <el-button type="primary" @click="getPullInvoice">拉取金蝶原始数据</el-button>
              <el-button type="primary" @click="openEmailDialog">推送邮箱地址</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="margin-20-0">
      <div class="table-container">
        <el-table
            :max-height="dynamicHeight"
            :data="invoiceLineDate"
            :stripe="true"
            :border="true"
            :highlight-current-row="true"
            size="default"
            row-key="id"
            ref="multipleTableRef"
            @selection-change="handleSelectionChange"
            @expand-change="handleExpandChange"
            :fit="true"
        >
          <el-table-column type="selection" width="40" fixed="left" />

          <el-table-column type="expand" label="详情" width="60px">
            <template #default="props">
              <div m="4">
                <el-table :data="props.row.items || []" :fit="true">
                  <el-table-column label="行号" prop="itemNumber"/>
                  <el-table-column label="销售编号" prop="invoiceNumber"/>
                  <el-table-column label="产品SKU编码" prop="productCode"/>
                  <el-table-column label="物料名称" prop="description" />
                  <el-table-column label="物料英文名称" prop="englishName" />
                  <el-table-column label="数量" prop="quantity" />
                  <el-table-column label="单价" prop="unitPrice">
                    <template #default="scope">
                      {{ parseFloat(scope.row.unitPrice || 0).toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column label="金额" prop="lineAmount">
                    <template #default="scope">
                      {{ parseFloat(scope.row.lineAmount || 0).toFixed(2) }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>

          <!-- 自动适应列宽的主要列 -->
          <el-table-column
              label="销售编号"
              prop="poNumber"
              show-overflow-tooltip
          ></el-table-column>

          <el-table-column
              label="客户名称"
              prop="customers"
              align="center"
              show-overflow-tooltip
          ></el-table-column>

          <el-table-column
              label="日期"
              prop="data"
              align="center"
          ></el-table-column>

          <el-table-column
              label="税前金额总额"
              prop="total"
              align="center"
          ></el-table-column>

          <el-table-column
              label="增值税金额"
              prop="vat"
              align="center"
          ></el-table-column>

          <el-table-column
              label="应付总额"
              prop="totalAmount"
              align="center"
          ></el-table-column>

          <el-table-column
              label="结算币别"
              prop="settlementCurrency"
              align="center"
          ></el-table-column>
          <el-table-column
              label="金蝶日期"
              prop="data"
              align="center"
          ></el-table-column>

          <el-table-column
              label="是否生成edi文件"
              prop="state"
              align="center"
          >
            <template #default="scope">
              <el-tag :type="scope.row.state===1?'success':'info'" size="small">
                {{scope.row.state===1?'已生成':'未生成'}}
              </el-tag>
            </template>
          </el-table-column>

          <!-- 固定操作列 -->
          <el-table-column
              label="操作"
              fixed="right"
              align="center">
            <template #default="scope">
              <el-button
                  link
                  type="primary"
                  size="small"
                  @click="handleSingleDownload(scope.row)"
              >
                生成edi文件
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="flex flex-row-center flex-item-center margin-10-0 ">
        <el-button style="margin-right:50vw" type="success" @click="handleBatchDownload">合单并生成edi文件</el-button>
        <el-pagination v-model:current-page="form.page"  :page-size="form.pageSize" :total="total" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" background layout="total, sizes, prev, pager, next,"  />
      </div>
    </div>

    <el-dialog v-model="drawer" title="请填写相对应的信息" center width="40vw" :close-on-click-modal="false">
      <template #default>
        <div class="dialog-container">
          <!-- 左侧区域 -->
          <div class="dialog-left">
            <el-form :model="formInline">

              <!-- 动态发票编号 -->
              <div v-if="!isStates">
                <el-form-item label="IRF->发票编号">
                  <el-input
                      v-model="formInline.deliveryNumber[0]"
                      placeholder="请输入订单的发票编号"
                      clearable
                  />
                </el-form-item>
              </div>
              <div v-if="isStates">
                <div v-for="(item, index) in selectedOrders" :key="index" class="cih-item">
                  <el-form-item :label="`IRF->${item?.poNumber ||  (index + 1)}：发票编号 ${index + 1}`">
                    <el-input
                        v-model="formInline.deliveryNumber[index]"
                        :placeholder="`请输入${item?.poNumber || '订单' + (index + 1)}的发票编号`"
                        clearable
                    />
                  </el-form-item>
                </div>
              </div>

              <!-- 基本信息 -->
              <el-form-item label="CLO->CIH会员编号">
                <el-input v-model="formInline.cihMemberNumber" placeholder="请输入接收方名称" clearable />
              </el-form-item>
              <el-form-item label="STX-SDT->接收方名称">
                <el-input v-model="formInline.invoiceNumber" placeholder="请输入接收方名称" clearable />
              </el-form-item>
              <el-form-item label="SDT->发送EDI地址">
                <el-input v-model="formInline.sendEdiAddress" placeholder="请输入发送EDI地址" clearable />
              </el-form-item>
              <el-form-item label="STX-CDT->接收方EDI地址">
                <el-input v-model="formInline.receiverEdiAddress" placeholder="请输入接收方EDI地址" clearable />
              </el-form-item>
              <el-form-item label="PYT->付款条文文本">
                <el-input v-model="formInline.paymentClauseText" placeholder="请输入付款条文文本" clearable />
              </el-form-item>
            </el-form>
          </div>

          <!-- 右侧区域 -->
          <div class="dialog-right">
            <el-form :model="formInline" >
              <!-- 动态送货单编号区域 -->
              <div v-if="!isStates">
                <el-form-item label="ODD->送货单编号">
                  <el-input
                      v-model="formInline.cihMemberOrderNumber[0]"
                      placeholder="请输入订单的送货单编号"
                      clearable
                  />
                </el-form-item>
              </div>
              <div v-if="isStates">
                <div v-for="(item, index) in selectedOrders" :key="index" class="cih-item">
                  <el-form-item :label="`ODD->${item?.poNumber ||  (index + 1)}：送货单编号 ${index + 1}`">
                    <el-input
                        v-model="formInline.cihMemberOrderNumber[index]"
                        :placeholder="`请输入${item?.poNumber || '订单' + (index + 1)}的送货单编号`"
                        clearable
                    />
                  </el-form-item>
                </div>
              </div>
              <!-- 日期选择器组 -->
              <el-form-item label="FDT->付款条款">
                <el-input v-model="formInline.paymentTerms" placeholder="请输入付款条款" clearable />
              </el-form-item>
              <el-form-item label="FDT->货物交付日期">
                <el-date-picker
                    v-model="formInline.deliveryDateEndTime"
                    type="date"
                    placeholder="请选择货物交付日期"
                    clearable
                />
              </el-form-item>
              <el-form-item label="IRF->纳税申报日期">
                <el-date-picker
                    v-model="formInline.taxTime"
                    type="date"
                    placeholder="请选择纳税申报日期"
                    clearable
                />
              </el-form-item>
              <el-form-item label="ODD->客户下单日期">
                <el-date-picker
                    v-model="formInline.invoiceDate"
                    type="date"
                    placeholder="请选择客户下单日期"
                    clearable
                />
              </el-form-item>
<!--              <el-form-item label="ODD->仓库发货日期">-->
<!--                <el-date-picker-->
<!--                    v-model="formInline.paymentDueDate"-->
<!--                    type="date"-->
<!--                    placeholder="请选择仓库发货日期"-->
<!--                    clearable-->
<!--                />-->
<!--              </el-form-item>-->
            </el-form>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="drawer = false">关闭</el-button>
          <el-button @click="resetForm">重置</el-button>
          <el-button type="primary" @click="submitEdiForm(this.selectedOrders.length)">提交</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 邮箱推送地址弹窗 -->
    <el-dialog v-model="emailDialog" title="邮箱推送地址" center width="60vw">
      <template #default>
        <div>
          <!-- 邮箱推送地址列表 -->
          <el-table :data="emailList" style="width: 100%" border>
            <el-table-column prop="host" label="host" />
            <el-table-column prop="port" label="port" />
            <el-table-column prop="username" label="username" />
            <el-table-column prop="senderEdiAddress" label="senderEdiAddress" />
            <el-table-column prop="receiverEdiAddress" label="receiverEdiAddress" />
            <el-table-column prop="data" label="data" />
            <el-table-column label="操作" width="150">
              <template #default="scope">
                <el-button
                  type="primary"
                  size="small"
                  @click="toggleEmailStatus(scope.row)"
                  :disabled="scope.row.isDefault === 0"
                >
                  {{ scope.row.isDefault === 0 ? '已启用' : '启用' }}
                </el-button>
                <el-button
                  type="danger"
                  size="small"
                  @click="toggleEmailStatus(scope.row)"
                  :disabled="scope.row.isDefault === 1"
                  style="margin-left: 8px"
                >
                  {{ scope.row.isDefault === 1 ? '已禁用' : '禁用' }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 新增邮箱推送地址 -->
          <div style="margin-top: 30px; border-top: 3px solid #606060; padding-top: 20px">
            <h3 style="margin-bottom: 20px; text-align: center">新增邮箱推送地址</h3>
            <el-form :model="newEmailForm" label-width="120px">
              <el-form-item label="host">
                <el-input v-model="newEmailForm.host" placeholder="请输入host" />
              </el-form-item>
              <el-form-item label="port">
                <el-input v-model="newEmailForm.port" placeholder="请输入port" />
              </el-form-item>
              <el-form-item label="username">
                <el-input v-model="newEmailForm.username" placeholder="请输入username" />
              </el-form-item>
              <el-form-item label="password">
                <el-input v-model="newEmailForm.password" placeholder="请输入password" />
              </el-form-item>
              <el-form-item label="senderEdiAddress">
                <el-input v-model="newEmailForm.senderEdiAddress" placeholder="请输入senderEdiAddress" />
              </el-form-item>
              <el-form-item label="receiverEdiAddress">
                <el-input v-model="newEmailForm.receiverEdiAddress" placeholder="请输入receiverEdiAddress" />
              </el-form-item>
              <el-form-item label="data">
                <el-input v-model="newEmailForm.data" placeholder="请输入备注" />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="emailDialog = false">关闭</el-button>
          <el-button type="primary" @click="addEmailAddress">新增</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  ElButton,
  ElDatePicker,
  ElInput,
  ElMessage,
  ElPagination,
  ElTable,
  ElFormItem,
  ElForm,
  ElTag,
  ElDialog,
  ElTableColumn,
  ElMessageBox
} from "element-plus";
import dayjs from "dayjs";
import DynamicHeightMixin from "../../../public/js/dynamicHeightMixin";
import {
  addInvoice,
  addOrUplMailAccountList,
  getEdiList,
  getInvoiceLineItems,
  getMailAccountList,
  pullInvoice
} from "@/utils/api";
export default {
  name: 'IndexEdi',
  mixins: [DynamicHeightMixin],
  components: {
    ElTable,ElTableColumn,ElPagination,ElButton,ElInput,ElDatePicker,ElFormItem,ElForm,ElTag,ElDialog
  },
  data() {
    return {
      isStates:false,
      formInline:{
        cihMemberNumber:'504',
        invoiceNumber:'SYLVOX VISION CO. LTD',
        invoiceDate:'',
        // paymentDueDate:'',
        sendEdiAddress:'1509990541',
        receiverEdiAddress:'5013546012900',
        invoiceEndTime:'',
        deliveryDateEndTime:'',
        paymentTerms:30,
        cihMemberOrderNumber:[],
        invoiceTime:'',
        taxTime:'',
        paymentClauseText:'Before 30 next month 0.00%',
        deliveryNumber:[],
        poNumber:[]
      },
      drawer:false,
      selectedOrders: [], // 存储选中的订单对象
      multipleSelection: [], // 存储表格选中的数据
      invoiceLineItemsDate:[],
      invoiceLineDate:[],
      dateRange:'',
      form:{
        poNumber:'',
        customers:'',
        beganData:'',
        endData:'',
        page:1,
        pageSize:50,
      },
      total:0,
      emailDialog: false,
      emailList: [],
      newEmailForm: {
        host: '',
        port: '',
        username: '',
        password: '',
        senderEdiAddress: '',
        receiverEdiAddress: '',
        isDefault: false,
        data: ''
      },
      dateShortcuts:[
        {
          text: "最近一周",
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          },
        },
        {
          text: "最近一个月",
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          },
        },
        {
          text: "最近三个月",
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 3);
            return [start, end];
          },
        },
      ],
    }
  },
  methods:{
    //展开
    handleExpandChange(row){
      if (row.items!=null){
        return
      }
      getInvoiceLineItems(row.poNumber).then(res=> {
        if (res.code === "200") {
          row.items = res.data
        } else {
          ElMessage.error(res.msg);
        }
      })
    },

    //选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 单个生成
    handleSingleDownload(row) {
      this.formInline.invoiceTime = row.data
      this.formInline.multipleSelection = []
      if (row.poNumber) {
        this.formInline.poNumber.push(row.poNumber)
        this.openDownloadDialog(row.poNumber, false);
      }
    },

    // 批量生成
    handleBatchDownload() {

      //判断>1并且<=10
      if (this.multipleSelection.length < 1 ) {
        ElMessage.warning('最少需要选择1条订单');
        return;
      }
      if (this.multipleSelection.length > 10) {
        ElMessage.warning('最多只能勾选10条订单');
        return;
      }

      this.isStates = true
      if (this.multipleSelection === undefined) {
        ElMessage.warning('请先选择要生成的订单');
        return;
      }
      const selectedOrders = this.multipleSelection
          .filter(item => item && item.poNumber)
          .map(item => item.poNumber);

      this.openDownloadDialog(selectedOrders, true);
    },

    // 打开生成对话框
    openDownloadDialog(poNumbers, isBatch) {
      ElMessageBox.confirm(
          isBatch
              ? `确定要将选中的 ${poNumbers.length} 个订单合并生成吗？`
              : `确定要生成订单 ${poNumbers} 吗？`,
          isBatch ? '合单生成' : '单订单生成',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true,
          }
      ).then(() => {
        this.drawer = true;
        if (isBatch){
          // 保存选中的订单对象
          this.selectedOrders = this.multipleSelection.filter(item =>
              item && item.poNumber && poNumbers.includes(item.poNumber)
          );
          // // 初始化送货单编号数组
          this.formInline.cihMemberOrderNumber = Array(this.selectedOrders.length).fill('');
          this.formInline.deliveryNumber = Array(this.selectedOrders.length).fill('');

        }else{
          this.selectedOrders = [{
            poNumber: poNumbers // 取第一个订单号
          }];
          // 初始化送货单编号数组（1个元素）
          this.formInline.cihMemberOrderNumber = Array(1).fill('');
          this.formInline.deliveryNumber = Array(1).fill('');
        }
      })
          .catch(() => {
            ElMessage.info('已取消操作');
          });
    },


    handleCurrentChange(val) {
      this.form.page = val;
      this.onSubmit();
    },

    handleSizeChange(val) {
      this.form.pageSize = val;
      this.onSubmit();
    },

    getPullInvoice(){
      // 1. 设置加载状态
      this.loading = true;
      pullInvoice().then(res => {
        if (res?.code === "200") {
          ElMessage.success('拉取成功');
          this.onSubmit()
        } else {
          // 业务错误处理
          ElMessage.error(res?.msg || '请求失败，请稍后重试');
        }
      }).catch(error => {
        // 网络/系统错误处理
        console.error('请求异常:', error);
        ElMessage.error('网络异常，请检查连接');
      }).finally(() => {
        this.loading = false;
      });
    },

    onSubmit() {
      // 1. 设置加载状态
      this.loading = true;

      // 2. 安全处理日期范围
      try {
        this.form.beganData = this.dateRange?.[0] ? dayjs(this.dateRange[0]).format("YYYY-MM-DD") : '';
        this.form.endData = this.dateRange?.[1] ? dayjs(this.dateRange[1]).format("YYYY-MM-DD") : '';
      } catch (e) {
        console.error('日期格式化错误:', e);
        this.form.beganData = '';
        this.form.endData = '';
      }

      // 3. 发起请求并处理响应
      getEdiList(this.form).then(res => {
        if (res?.code === "200") {  // 使用可选链避免res为undefined
          // 成功响应处理
          this.invoiceLineDate = res.data?.data || [];  // 默认空数组
          this.form.page = res.data?.currentPage || 1;
          this.form.pageSize = res.data?.pageSize || 10;
          this.total = res.data?.total || 0;
        } else {
          // 业务错误处理
          ElMessage.error(res?.msg || '请求失败，请稍后重试');
        }
      }).catch(error => {
        // 网络/系统错误处理
        console.error('请求异常:', error);
        ElMessage.error('网络异常，请检查连接');
      }).finally(() => {
        this.loading = false;
      });
    },

    // 重置表单
    resetForm() {
      this.formInline = {
        cihMemberNumber:'504',
        invoiceNumber:'SYLVOX VISION CO. LTD',
        invoiceDate:'',
        // paymentDueDate:'',
        sendEdiAddress:'1509990541',
        receiverEdiAddress:'5013546012900',
        InvoiceEndTime:'',
        deliveryDateEndTime:'',
        paymentTerms:'',
        cihMemberOrderNumber:[],
        invoiceTime:'',
        taxTime:'',
        paymentClauseText:'Before 30 next month 0.00%',
        deliveryNumber:[],
        poNumber:[]
      };
      this.formInline.cihMemberOrderNumber = Array(this.selectedOrders.length).fill('');
      this.formInline.deliveryNumber = Array(this.selectedOrders.length).fill('');
    },

    // 提交EDI表单
    submitEdiForm(state) {
      // 批量模式验证
      if (state !== 0) {
        const emptyCihIndex = this.formInline.cihMemberOrderNumber.findIndex(cih => !cih || cih.trim() === '');
        if (emptyCihIndex !== -1) {
          ElMessage.warning(`请输入第 ${emptyCihIndex + 1} 个送货单编号`);
          return;
        }
        this.formInline.poNumber = this.selectedOrders.map(item => item.poNumber);
      }
      if (state !== 0) {
        const emptyCihIndex = this.formInline.deliveryNumber.findIndex(cih => !cih || cih.trim() === '');
        if (emptyCihIndex !== -1) {
          ElMessage.warning(`请输入第 ${emptyCihIndex + 1} 个发票编号`);
          return;
        }
        this.formInline.poNumber = this.selectedOrders.map(item => item.poNumber);
      }

      // 完整验证
      const missingFields = this.checkRequiredFields();
      if (missingFields.length > 0) {
        ElMessage.warning(`以下字段不能为空：${missingFields.join('、')}`);
        return;
      }

      // 提交
      addInvoice(this.formInline).then(res => {
        if (res.code === "200") {
          ElMessage.success("生成成功！");
          this.onSubmit();
          this.resetForm();
          this.drawer = false;
        } else {
          ElMessage.error(res.msg);
        }
      });
    },

// 检查必填字段
    checkRequiredFields() {
      const form = this.formInline;
      const missing = [];

      // 文本字段检查
      const textFields = [
        { value: form.cihMemberNumber, name: 'CIH会员编号' },
        { value: form.invoiceNumber, name: '接收方名称' },
        { value: form.sendEdiAddress, name: '发送EDI地址' },
        { value: form.receiverEdiAddress, name: '接收方EDI地址' },
        { value: form.paymentClauseText, name: '付款条文文本' },
        { value: form.paymentTerms, name: '货物付款条款' },
        { value: form.deliveryNumber, name: '送货单号' }
      ];

      textFields.forEach(({ value, name }) => {
        if (!value || value.toString().trim() === '') {
          missing.push(name);
        }
      });

      // 日期字段检查
      const dateFields = [
        { value: form.invoiceDate, name: '客户下单日期' },
        // { value: form.paymentDueDate, name: '仓库发货期日' },
        { value: form.taxTime, name: '纳税申报日期' },
        { value: form.deliveryDateEndTime, name: '货物交付日期' },
      ];

      dateFields.forEach(({ value, name }) => {
        if (!this.isValidDate(value)) {
          missing.push(name);
        }
      });

      // CIH编号数组检查
      if (form.cihMemberOrderNumber) {
        form.cihMemberOrderNumber.forEach((cih, index) => {
          if (!cih || cih.trim() === '') {
            missing.push(`第${index + 1}个送货单编号`);
          }
        });
      }
      if (form.deliveryNumber) {
        form.deliveryNumber.forEach((cih, index) => {
          if (!cih || cih.trim() === '') {
            missing.push(`第${index + 1}个发票编号`);
          }
        });
      }

      return missing;
    },

    //验证日期
    isValidDate(date) {
      if (!date) return false;
      const dateObj = date instanceof Date ? date : new Date(date);
      return dateObj instanceof Date && !isNaN(dateObj.getTime());
    },

    // 打开邮箱推送地址弹窗
    openEmailDialog() {
      this.emailDialog = true;
      this.loading = true;
      this.getMailAccountList()
    },

    // 邮箱列表
    getMailAccountList() {
      getMailAccountList().then(res => {
        if (res?.code === "200") {
          // 成功响应处理
          this.emailList = res.data || [];
        } else {
          // 业务错误处理
          ElMessage.error(res?.msg || '请求失败，请稍后重试');
        }
      }).catch(error => {
        // 网络/系统错误处理
        console.error('请求异常:', error);
        ElMessage.error('网络异常，请检查连接');
      }).finally(() => {
        this.loading = false;
      });
    },

    // 切换邮箱状态
    toggleEmailStatus(row) {
      console.log(row.isDefault);
      const currentStatus = row.isDefault;
      const newStatus = currentStatus === 0 ? 1 : 0;

      if (newStatus === 0) {
        // 要启用，检查是否已有启用的数据
        const hasEnabled = this.emailList.some(item => item.isDefault === 0 && item.id !== row.id);
        if (hasEnabled) {
          ElMessage.warning('已有启用的邮箱地址');
          return;
        }
      }

      row.isDefault = newStatus;
      addOrUplMailAccountList(row).then(res => {
        if (res.code === "200") {
          ElMessage.success(`邮箱地址已${newStatus === 0 ? '启用' : '禁用'}`);
          this.onSubmit();
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(error => {
        // 网络/系统错误处理
        console.error('请求异常:', error);
        ElMessage.error('网络异常，请检查连接');
      });
    },

    // 新增邮箱地址
    addEmailAddress() {
      // 非空判断
      if (!this.newEmailForm.host || this.newEmailForm.host.trim() === '') {
        ElMessage.warning('请输入host');
        return;
      }
      if (!this.newEmailForm.port || this.newEmailForm.port.trim() === '') {
        ElMessage.warning('请输入port');
        return;
      }
      if (!this.newEmailForm.username || this.newEmailForm.username.trim() === '') {
        ElMessage.warning('请输入username');
        return;
      }
      if (!this.newEmailForm.password || this.newEmailForm.password.trim() === '') {
        ElMessage.warning('请输入password');
        return;
      }
      if (!this.newEmailForm.senderEdiAddress || this.newEmailForm.senderEdiAddress.trim() === '') {
        ElMessage.warning('请输入senderEdiAddress');
        return;
      }
      if (!this.newEmailForm.receiverEdiAddress || this.newEmailForm.receiverEdiAddress.trim() === '') {
        ElMessage.warning('请输入receiverEdiAddress');
        return;
      }
      if (!this.newEmailForm.data || this.newEmailForm.data.trim() === '') {
        ElMessage.warning('请输入data');
        return;
      }

      // 添加新邮箱地址
      const newEmail = {
        host: this.newEmailForm.host,
        port: this.newEmailForm.port,
        senderEdiAddress: this.newEmailForm.senderEdiAddress,
        receiverEdiAddress: this.newEmailForm.receiverEdiAddress,
        username: this.newEmailForm.username,
        password: this.newEmailForm.password,
        isDefault: this.newEmailForm.isDefault===true ? 0 : 1, // 默认禁用
      };

      addOrUplMailAccountList(newEmail).then(res => {
        if (res.code === "200") {
          this.getMailAccountList()
        } else {
          ElMessage.error(res.msg);
        }
      });
      // 重置表单
      this.newEmailForm = {
        host: '',
        port: '',
        senderEdiAddress: '',
        receiverEdiAddress: ''
      };

      ElMessage.success('邮箱地址添加成功');
    }
  },
  created() {
    this.onSubmit()
  },
}
</script>

<style>

.container{
  width: 94%;
  margin:0 auto;
}
::v-deep .container .el-form-item{
  margin-bottom:0!important;
  margin: 0 10px;
  --font-size: 14px;
  margin-bottom: 18px;
}
::v-deep .el-button+.el-button{
  margin-left: 0 !important;
}
.dialog-container {
  display: flex;
  max-height: 60vh;
  overflow-y: auto;
}

.dialog-left,
.dialog-right {
  flex: 1;
  min-width: 0;
}

.dialog-left {
  border-right: 1px solid #e8e8e8;
  padding-right: 10px;
}

.dialog-right {
  padding-left: 10px;
}

.cih-item {
  margin-bottom: 16px;
  background: #f8f9fa;
  border-radius: 37px;
  border-left: 2px solid #409eff;
}


.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e8e8e8;
}

/* 响应式设计 */
@media (max-width: 1600px) {
  .dialog-container {
    flex-direction: column;
    gap: 20px;
  }

  .dialog-left {
    border-right: none;
    border-bottom: 1px solid #e8e8e8;
    padding-right: 0;
    padding-bottom: 20px;
  }

  .dialog-right {
    padding-left: 0;
  }
}
</style>
